import { createContext, useState, useEffect, useContext } from "react";
import { AccountContext } from "./AccountContexts";
import { BACKEND_URI } from "../entries";
import io from 'socket.io-client'
import { getNotificationNumbers, getUnreadMessages, onNumberNotifications, onTicketUpdatedPing, onUnreadMessage, onUnreadMessages } from "../utils/notificationUtils";
import { onNewActiveChat, onRemoveActiveChat } from "../utils/messagingUtils";
import { getCookie } from "../utils";
import { devLog } from "../utils/loggerUtils";


const NotificationContext = createContext();

function NotificationController(props) {
    const { user } = useContext(AccountContext)

    const [socket, setSocket] = useState(null)

    const [numberNotifications, setNumberNotifications] = useState(0)

    const [newMessageNotifications, setNewMessageNotifications] = useState({})

    const [isSidebar, setIsSidebar] = useState(true)
    const [chatTickets, setChatTickets] = useState([])
    const [playerAnnouncements, setPlayerAnnouncements] = useState([])
    const [employeeAnnouncements, setEmployeeAnnouncements] = useState([])

    const initializeSocket = () => {
        const token = getCookie("Mobile2CredentialsManager.CSRFToken")
        const socket_init = io(BACKEND_URI, {
            reconnection: true,            // Enable reconnection
            reconnectionAttempts: 5,       // Number of attempts before giving up
            reconnectionDelay: 1000,       // Delay between reconnection attempts (in ms)
            reconnectionDelayMax: 5000,    // Maximum delay between reconnection attempts
            timeout: 20000,                // Timeout after which to consider the connection failed (in ms)
            path: "/socket.io",
            extraHeaders: {
                'X-CSRF-Token': token || ""
            },
            transports: ['websocket'],     // Ensure WebSocket transport is used
            withCredentials: true,
        })
        console.info("initializing socket")
        setSocket(socket_init)
    }
    useEffect(() => {
        initializeSocket()
    }, [])


    function requestNotificationPermission() {
        if ("Notification" in window) {
            Notification.requestPermission().then(permission => {
                if (permission === "granted") {
                    devLog("Notification permission granted.");
                }
            });
        }
    }


    function showNotification(title, body) {
        if (Notification.permission === "granted") {
            new Notification(title, {
                body: body,
                icon: process.env.PUBLIC_URL + "/logo512.png" // Optional: set an icon for branding
            });
        }
    }


    const [connectionLost, setConnectionLost] = useState(false)
    const [reconnected, setReconnected] = useState(false)

    useEffect(() => {
        const socketCheckInterval = setInterval(() => {
            if (socket && socket.connected) {
                if (connectionLost) {
                    // initializeSocket()
                    setConnectionLost(false)
                    setReconnected(true)
                    devLog("reconnected")
                }
            }
            else if (socket && socket.disconnected) {
                !connectionLost && setConnectionLost(true)
                setReconnected(false)
            }
        }, 1000)

        return () => {
            clearInterval(socketCheckInterval)
        }
    }, [socket, connectionLost])

    useEffect(() => {



        if (user && socket) {
            devLog(socket.connected ? "connected" : "not connected")
            socket.emit('join_chatroom', { room_id: user.id, name: user.id })
            setTimeout(() => {
                getNotificationNumbers({ socket: socket })
                getUnreadMessages({ socket: socket, userId: user.id })
            }, 500)

            if (user.class === "dev") {

                onNumberNotifications({ socket: socket, setNumberNotifications: setNumberNotifications })

                onUnreadMessages({ socket: socket, setNewMessageNotifications: setNewMessageNotifications })
                onUnreadMessage({ socket: socket, setNewMessageNotifications: setNewMessageNotifications })

                onTicketUpdatedPing({ socket: socket, setTickets: setChatTickets })

                onRemoveActiveChat({ socket: socket, setTickets: setChatTickets })

                onNewActiveChat({ socket: socket, setTickets: setChatTickets })
            }

        }

    }, [socket, reconnected])

    useEffect(() => {
        if (socket && socket.connected) {
            devLog(socket.connected ? "CONNECTED" : "not connected")
        }
    }, [])

    useEffect(() => {
        if (user) {
            requestNotificationPermission()
        }
    }, [user])


    if (socket) {

        socket.off('reconnect_attempt')
        socket.on('reconnect_attempt', () => {
            console.info('Attempting to reconnect...');
        });

        socket.off('reconnect_failed')
        socket.on('reconnect_failed', () => {
            console.info('Reconnection failed');
        });

        socket.off('reconnect')
        socket.on('reconnect', (attemptNumber) => {
            console.info(`Reconnected after ${attemptNumber} attempts`);
        });

        socket.off('disconnect')
        socket.on('disconnect', (reason) => {
            console.info('Socket disconnected:', reason);
            if (reason === 'io server disconnect') {
                // The server disconnected the socket manually (e.g., by calling socket.disconnect())
                socket.connect(); // You need to manually reconnect in this case
            } else {
                // Otherwise, the socket will automatically try to reconnect
                console.info('Trying to reconnect...');
            }
        });
    }

    const [isTabActive, setIsTabActive] = useState(true);
    useEffect(() => {
        const handleVisibilityChange = () => {
            setIsTabActive(!document.hidden);
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    if (!socket) {
        return <>
            <h1>No connection</h1>
        </>
    }

    return (
        <NotificationContext.Provider
            value={{
                socket,
                setSocket,
                numberNotifications,
                setNumberNotifications,
                isSidebar,
                setIsSidebar,
                newMessageNotifications,
                setNewMessageNotifications,
                chatTickets,
                setChatTickets,
                initializeSocket,
                reconnected,
                connectionLost,
                showNotification,
                isTabActive,
                playerAnnouncements,
                setPlayerAnnouncements,
                employeeAnnouncements,
                setEmployeeAnnouncements,
            }}>
            {props.children}
        </NotificationContext.Provider>
    )


}


export { NotificationContext, NotificationController };